export const formOrderObjFromCart = (data = null, osType = null, serverType = null, sku = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const dataDisks = data?.itemDetail?.catalogService?.catalogConfig?.diskDefinitions || null;
    const os = data?.itemDetail?.catalogService?.catalogConfig?.os || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    const getDataDisks = () => {
        return dataDisks?.map((item) => ({
            // eslint-disable-next-line
            diskType: item?.diskType ? item?.diskType : ['Production'].includes(environmentDetails?.environment) ? 'Premium SSD' : 'Standard SSD',
            diskDriveLetter: item?.diskDriveLetter || '',
            mountPoint: item?.mountPoint || '',
            // eslint-disable-next-line
            fsType: item?.fsType ? item?.fsType : os?.osType === 'Windows' ? 'NTFS' : 'ext4',
            diskSizeInGib: item?.diskSizeInGib,
        }));
    };
    const envDetailsTemp = {
        'DR Priority': environmentDetails?.drPriority,
        Metallic_Selection: environmentDetails?.metallic,
        Backup_Tier: environmentDetails?.backupTier,
        Subscription: environmentDetails?.subscription,
        Resource_Group: environmentDetails?.resourceGroup,
        Virtual_Network: environmentDetails?.virtualNetwork,
        Subnet_Name: environmentDetails?.subNetName,
        Approval_Manager: entityDetails?.applicationManager,
        Project: environmentDetails?.projectName,
        Availability_Zones: environmentDetails?.availabilityZones,
        Azure_Site_Recovery: environmentDetails?.asr ? 'Yes' : 'No',
    };
    return {
        envDetailsTemp,
        availabilityZoneOptions: environmentDetails?.availabilityZones,
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: {
                    applicationServices: [
                        {
                            businessCriticality: catalogConfig?.appBusinessCriticality,
                        },
                    ],
                    dataClassification: catalogConfig?.tags?.['pep-dataclassification'],
                },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        ...(catalogConfig?.microServiceId && {
            microService: catalogConfig?.microServiceName,
            microServiceDetails: {
                label: catalogConfig?.microServiceName,
                value: catalogConfig?.microServiceName,
                data: {
                    microserviceId: catalogConfig?.microServiceId,
                    microserviceName: catalogConfig?.microServiceName,
                    number: catalogConfig?.microServiceNumber,
                },
            },
        }),
        entityDetails: {
            ...entityDetails,
            owner: { name: entityDetails?.applicationManager, emailId: entityDetails?.applicationManagerEmail, id: entityDetails?.applicationManagerGpid },
            financialDetails: entityDetails?.costCenter,
            projectName: entityDetails?.project,
        },
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        subscription: environmentDetails?.subscription,
        subscriptionId: environmentDetails?.subscriptionId,
        subscriptionDetails: {
            label: environmentDetails?.subscription,
            value: environmentDetails?.subscription,
            data: {
                name: environmentDetails?.subscription,
                subscriptionId: environmentDetails?.subscriptionId,
            },
        },
        resourceGroup: environmentDetails?.resourceGroup,
        resourceGroupDetails: {
            label: environmentDetails?.resourceGroup,
            value: environmentDetails?.resourceGroup,
        },
        vnetDR: environmentDetails?.virtualNetwork,
        vnetDRDetails: {
            label: environmentDetails?.virtualNetwork,
            value: environmentDetails?.virtualNetwork,
            data: {
                vnetId: environmentDetails?.virtualNetworkId,
            },
        },
        subnetDR: environmentDetails?.subNetName,
        tagsQc: { ...catalogConfig?.tags },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        sector: data?.itemDetail?.catalogService?.sector || null,
        billingEntity: catalogConfig?.billingEntity || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        environment: environmentDetails?.environment || null,
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        region: environmentDetails?.region || null,
        // regionDisplayName: data?.region?.name || null,
        osVersion: os?.publisher ? `${os?.publisher},${os?.sku}` : null,
        osVersionDetail: {
            offer: os?.offer,
            publisher: os?.publisher,
            sku: os?.sku,
            version: os?.version,
            hyperVGeneration: os?.hyperVGeneration,
        },
        osType: os?.osType,
        sku,
        vmType: data?.itemDetail?.catalogService?.catalogConfig?.vmType || null,
        dataDisksCount: dataDisks?.length || 0,
        catalogOffer: os?.offer,
        dbSizeDetails: { valueInGB: parseInt(catalogConfig?.dataBaseSize, 10) },
        dataDisks: getDataDisks() || [],
        domain: environmentDetails?.domain || null,
        // domainDetail: data?.domain || null,
        adousDefault: environmentDetails?.adOu || 'Default OU',
        adous: environmentDetails?.adOu,
        adousDetails: { fullpath: environmentDetails?.adOu },
        ...(osType === 'Windows' && { adGroup: data?.itemDetail?.catalogService?.catalogConfig?.adGroup || '' }),
        ...(osType === 'Linux' && { samAccountId: data?.itemDetail?.catalogService?.catalogConfig?.samAccountId || '' }),
        ...(environmentDetails?.availabilityZones && {
            haDeployment: 'Availability Zones',
            availabilityZone: environmentDetails?.availabilityZones,
            isValidAvailabilityZone: true,
        }),
        ...(environmentDetails?.availabilitySet && {
            haDeployment: 'Availability Set',
            isValidAvailabilityZone: true,
        }),
        ...(catalogConfig?.serverRefresh && {
            retiringServerName: catalogConfig?.retiringServerName || null,
            retiringServerSysId: catalogConfig?.retiringServerSysId || null,
            scheduledRetirement: catalogConfig?.scheduledRetirement || null,
            disposalReason: catalogConfig?.disposalReason || null,
        }),
        quantity: data?.itemDetail?.catalogService?.quantity,
        timeZone: data?.itemDetail?.catalogService?.timeZone,
        acceleratedNetworking: catalogConfig?.acceleratedNetworking === true ? 'yes' : 'no',
        ...(catalogConfig?.pacemakerClusterRequired === false && { serverRefresh: catalogConfig?.serverRefresh === true ? 'yes' : 'no' }),
        serverType,
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null, osType = null, serverType = null, sku = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const dataDisks = catalogConfig?.diskDefinitions || null;
    const os = catalogConfig?.os || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const getDataDisks = () => {
        return dataDisks?.map((item) => ({
            // eslint-disable-next-line
            diskType: item?.diskType ? item?.diskType : ['Production'].includes(environmentDetails?.environment) ? 'Premium SSD' : 'Standard SSD',
            diskDriveLetter: item?.diskDriveLetter || '',
            mountPoint: item?.mountPoint || '',
            // eslint-disable-next-line
            fsType: item?.fsType ? item?.fsType : os?.osType === 'Windows' ? 'NTFS' : 'ext4',
            diskSizeInGib: item?.diskSizeInGib,
        }));
    };
    const envDetailsTemp = {
        'DR Priority': environmentDetails?.drPriority,
        Metallic_Selection: environmentDetails?.metallic,
        Backup_Tier: environmentDetails?.backupTier,
        Subscription: environmentDetails?.subscription,
        Resource_Group: environmentDetails?.resourceGroup,
        Virtual_Network: environmentDetails?.virtualNetwork,
        Subnet_Name: environmentDetails?.subNetName,
        Approval_Manager: entityDetails?.applicationManager,
        Project: environmentDetails?.projectName,
        Availability_Zones: environmentDetails?.availabilityZones,
        Azure_Site_Recovery: environmentDetails?.asr ? 'Yes' : 'No',
    };
    return {
        envDetailsTemp,
        availabilityZoneOptions: environmentDetails?.availabilityZones,
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: {
                    applicationServices: [{ businessCriticality: catalogConfig?.appBusinessCriticality }],
                    dataClassification: catalogConfig?.tags?.['pep-dataclassification'],
                },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        ...(catalogConfig?.microServiceId && {
            microService: catalogConfig?.microServiceName,
            microServiceDetails: {
                label: catalogConfig?.microServiceName,
                value: catalogConfig?.microServiceName,
                data: {
                    microserviceId: catalogConfig?.microServiceId,
                    microserviceName: catalogConfig?.microServiceName,
                    number: catalogConfig?.microServiceNumber,
                },
            },
        }),
        entityDetails: {
            ...entityDetails,
            owner: { name: entityDetails?.applicationManager, emailId: entityDetails?.applicationManagerEmail, id: entityDetails?.applicationManagerGpid },
            financialDetails: environmentDetails?.costCenter,
            projectName: environmentDetails?.projectName,
            billingEntity: catalogConfig?.billingEntity,
            sector: catalog?.sector,
        },
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        subscription: environmentDetails?.subscription,
        subscriptionId: environmentDetails?.subscriptionId,
        subscriptionDetails: {
            label: environmentDetails?.subscription,
            value: environmentDetails?.subscription,
            data: {
                name: environmentDetails?.subscription,
                subscriptionId: environmentDetails?.subscriptionId,
            },
        },
        resourceGroup: environmentDetails?.resourceGroup,
        resourceGroupDetails: {
            label: environmentDetails?.resourceGroup,
            value: environmentDetails?.resourceGroup,
        },
        vnetDR: environmentDetails?.virtualNetwork,
        vnetDRDetails: {
            label: environmentDetails?.virtualNetwork,
            value: environmentDetails?.virtualNetwork,
            data: {
                vnetId: environmentDetails?.virtualNetworkId,
            },
        },
        subnetDR: environmentDetails?.subNetName,
        tagsQc: { ...catalogConfig?.tags },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        sector: catalog?.sector || null,
        billingEntity: catalogConfig?.billingEntity || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        environment: environmentDetails?.environment || null,
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        region: environmentDetails?.region || null,
        osVersion: os?.publisher ? `${os?.publisher},${os?.sku}` : null,
        osVersionDetail: {
            offer: os?.offer,
            publisher: os?.publisher,
            sku: os?.sku,
            version: os?.version,
            hyperVGeneration: os?.hyperVGeneration,
        },
        osType: os?.osType,
        sku,
        vmType: catalogConfig?.vmType || null,
        dataDisksCount: dataDisks?.length || 0,
        catalogOffer: os?.offer,
        dbSizeDetails: { valueInGB: parseInt(catalogConfig?.dataBaseSize, 10) },
        dataDisks: getDataDisks() || [],
        domain: environmentDetails?.domain || null,
        // domainDetail: data?.domain || null,
        adousDefault: environmentDetails?.adOu || 'Default OU',
        adous: environmentDetails?.adOu,
        adousDetails: { fullpath: environmentDetails?.adOu },
        ...(osType === 'Windows' && { adGroup: catalogConfig?.adGroup || '' }),
        ...(osType === 'Linux' && { samAccountId: catalogConfig?.samAccountId || '' }),
        ...(environmentDetails?.availabilityZones && {
            haDeployment: 'Availability Zones',
            availabilityZone: environmentDetails?.availabilityZones,
            isValidAvailabilityZone: true,
        }),
        ...(environmentDetails?.availabilitySet && {
            haDeployment: 'Availability Set',
            isValidAvailabilityZone: true,
        }),
        ...(catalogConfig?.serverRefresh && {
            retiringServerName: catalogConfig?.retiringServerName || null,
            retiringServerSysId: catalogConfig?.retiringServerSysId || null,
            scheduledRetirement: catalogConfig?.scheduledRetirement || null,
            disposalReason: catalogConfig?.disposalReason || null,
        }),
        acceleratedNetworking: catalogConfig?.acceleratedNetworking === true ? 'yes' : 'no',
        ...(catalogConfig?.pacemakerClusterRequired === false && { serverRefresh: catalogConfig?.serverRefresh === true ? 'yes' : 'no' }),
        quantity: catalog?.quantity,
        timeZone: catalog?.timeZone,
        serverType,
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const resetOrder = {
    appProfile: null,
    appProfileDetails: null,
    entityDetails: null,
    microService: null,
    microServiceDetails: null,
    microServiceOptionsAvailable: false,
    businessCategory: null,
    environment: null,
    appTier: null,
    appTierCode: null,
    region: null,
    regionDisplayName: null,
    envDetails: null,
    osVersion: null,
    osVersionDetail: null,
    osDiskType: null,
    vmType: null,
    vmTypeDetails: null,
    quantity: 1,
    maxDataDiskCount: null,
    dataDisksCount: null,
    dataDisks: [],
    defaultDataDisks: [],
    adGroup: null,
    hoursOfOperation: null,
    hoursOfOperationDetail: null, // { active: 1, id: '763cf923-85d9-43f7-b338-7be17fded399', name: 'Always ON', type: 'hours_of_operation' },
    timeZone: 'UTC',
    timeZoneDetail: null, // { id: 'd3bb59b6-72b3-49c0-a1c2-c0494ea28802', name: 'UTC', type: 'time_zones', value: 'Default-UTC' }
    domain: null,
    domainDetails: null,
    hCode: null,
    hCodeDetails: null,
    billingEntity: null,
    billingEntityDetails: null,
    adousDefault: null,
    adous: null,
    adousDetails: null,
    sector: null,
    sectorDetails: null,
    tags: [],
    tagsQc: null,
    estimatedCost: resetCostEstimateDetails,
    acceleratedNetworking: 'yes',
    serverRefresh: 'no',
    validationStatus: 'clearValidation',
    isTouched: false,
    haDeployment: null,
    availabilityZone: null,
    availabilityZoneOptions: [],
    retiringServerName: null,
    retiringServerSysId: null,
    disposalReason: null,
    scheduledRetirement: null,
    sapGid: null,
    sapSid: null,
    sapAccountOwner: null,
    sapAccountOwnerDetails: null,
    Gid: null,
    Uid: null,
    catalogOffer: null,
    catalogOfferDetail: null,
    dbSize: null,
    dbSizeDetails: null,
    isPacemakerClusterRequired: 'no',
    fqdns: '',
    frontendPort: '',
    backendPort: '',
    protocol: null,
    hpProtocol: null,
    port: '',
    urlPath: '',
    sapEnvironment: null,
};

export const resetForQuickConfig = {
    environment: null,
    appTier: null,
    appTierCode: null,
    region: null,
    regionDisplayName: null,
    osVersion: null,
    osVersionDetail: null,
    vmType: null,
    vmTypeDetails: null,
    dataDisksCount: 0,
    dataDisks: [],
    domain: null,
    domainDetail: null,
    adousDefault: null,
    haDeployment: null,
    availabilityZone: null,
    availabilityZoneOptions: [],
};

export const resetEnvironmentDetails = {
    Subscription: '-',
    'DR Priority': '-',
    Resource_Group: '-',
    Metallic_Selection: '-',
    Backup_Tier: '-',
    Virtual_Network: '-',
    // Network_Security_Group: '-',
    Subnet_Name: '-',
    // Application_Security_Group: '-',
    // Recovery_Vault_Name: '-',
    Approval_Manager: '-',
    Project: '-',
    Availability_Set: '-',
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isDiskOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
    isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
    isPgtDiskOpen: false,
};
export const checkMountPointExists = (mountPoint, disableFields = false, reservedPaths = []) => {
    if (!disableFields) {
        const mountPoints = reservedPaths || [];
        // const expression=/^\/[a-zA-Z][a-zA-Z0-9_-]*$/;
        let ValidMountPoint = { shhowMessage: false, message: null };
        if (mountPoint && (mountPoint !== '' || mountPoint !== null)) {
            if (!/^\/(?:[a-zA-Z0-9_-]+\/?)*$/?.test(mountPoint)) {
                ValidMountPoint = { shhowMessage: true, message: 'should start with / followed by alphabet ' };
            } else if (mountPoints.indexOf(mountPoint) > -1) {
                ValidMountPoint = {
                    shhowMessage: true,
                    message: `following paths are reserved
                ${reservedPaths?.join(', ')}`,
                };
            } else {
                ValidMountPoint = { shhowMessage: false, message: null };
            }
        }
        return ValidMountPoint;
    }
    return '';
};

export const isMountPointDuplicate = (dataDisks) => {
    const mountPointsArray = dataDisks?.filter((disk) => disk?.mountPoint && disk?.mountPoint)?.map((d) => d?.mountPoint) || [];
    return new Set(mountPointsArray)?.size !== mountPointsArray?.length;
};
export const getDataDiskSize = (data) => {
    const size = data?.values[0]?.possibleValues || [];
    return size.map((item) => item);
};
export const isValidMountPoint = (disableField, mountPt) => {
    let result = true;
    if (!disableField) {
        // result = mountPt?.charAt(0) === '/';
        result = /^\/(?:[a-zA-Z0-9_-]+\/?)*$/?.test(mountPt);
    }
    return result;
};

export const ispgthanaFormValid = (dataDisks, reservedPaths) => {
    let errorCount = 0;
    let isDataDiskValid = false;
    if (dataDisks?.length) {
        dataDisks?.forEach((disk) => {
            if (
                !(
                    (disk?.disableFields &&
                        disk.diskSizeInGib !== '' &&
                        disk.diskType !== '' &&
                        disk.diskCount !== '' &&
                        disk.diskCount !== 0 &&
                        (disk?.diskTier && disk?.diskTier !== null ? /^[0-9]+$/.test(disk.diskCount) : true) &&
                        disk.diskCount !== '0' &&
                        disk.totalSize !== undefined &&
                        disk.totalSize !== '') ||
                    (!disk?.disableFields &&
                        disk.diskSizeInGib !== '' &&
                        disk.diskType !== '' &&
                        disk.mountPoint !== '' &&
                        disk.mountPoint !== undefined &&
                        disk.fsType !== '' &&
                        !reservedPaths?.includes(disk.mountPoint) &&
                        isValidMountPoint(disk?.disableFields, disk?.mountPoint))
                )
            ) {
                // eslint-disable-next-line no-plusplus
                errorCount++;
            }
        });
    }
    isDataDiskValid = errorCount === 0;
    return isDataDiskValid;
};

export const isHpFormFilled = ({ order, validPort }) =>
    !(
        order?.port &&
        !validPort &&
        order?.hpProtocol &&
        (['https', 'http'].includes(order?.hpProtocol?.toLowerCase()) ? !(!order?.urlPath || order?.urlPath === '') : true)
    );
